import { z } from 'zod';
import { AttributeChange, EventName, IsoDateTime, OperationEnvelope, Properties } from './common.ts';
import { AliasRef, ExternalId, UserRef } from './identity.ts';
import { ChannelStates, GroupState } from './subscriptions.ts';

/** `POST /server/v1/batch` (BB-25), server key with scope `ingest.write`; the environment comes from the key. */
export const ServerBatchRequest = z.object({
  schemaVersion: z.literal(1),
  batchId: z.uuid(),
  sentAt: IsoDateTime.optional(),
  operations: z.array(OperationEnvelope).min(1).max(100),
});
export type ServerBatchRequest = z.infer<typeof ServerBatchRequest>;

export const ServerOperation = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('event'),
    operationId: z.uuid(),
    user: UserRef,
    occurredAt: IsoDateTime,
    name: EventName,
    properties: Properties.optional(),
    appInstanceId: z.uuid().optional(),
    createIfMissing: z.boolean().default(true),
  }),
  z.object({
    type: z.literal('attributes'),
    operationId: z.uuid(),
    user: UserRef,
    occurredAt: IsoDateTime.optional(),
    changes: z.array(AttributeChange).min(1).max(100),
    createIfMissing: z.boolean().default(true),
  }),
  z.object({
    type: z.literal('subscription'),
    operationId: z.uuid(),
    user: UserRef,
    occurredAt: IsoDateTime,
    channels: ChannelStates.optional(),
    groups: z.array(GroupState).max(50).optional(),
    reason: z.string().max(200).optional(),
  }),
  z.object({ type: z.literal('alias_add'), operationId: z.uuid(), user: z.strictObject({ externalId: ExternalId }), alias: AliasRef }),
  z.object({ type: z.literal('alias_identify'), operationId: z.uuid(), alias: AliasRef, externalId: ExternalId }),
]);
export type ServerOperation = z.infer<typeof ServerOperation>;
